import React, { useState } from 'react';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import useAuth from 'hooks/useAuth';
import useConfig from 'hooks/useConfig';
import { useGetMenuMaster } from 'api/menu';

import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import LoginSection from './LoginSection';
import RegisterSection from './RegistrationSection';
import ForgotSection from './ForgotPasswordSection';
import { MenuOrientation } from 'types/config';
import KycPopUp from './KycPopup';
import CookieTerms from './CookieTerms';
import Container from '@mui/material/Container';
import LogoSectionMobile from '../LogoSection/indexmobile';
import { useLocation } from 'react-router-dom';
import KycDeclinedPopUp from './KycDeclinedPopUp';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const hostname = window.location.hostname;

const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

const parts = hostname.replace(/^www\./, '').split('.');

// main domain like peryaplay.ph → 2 parts
// any subdomain → more than 2 parts
const hasSubdomain = !isLocalhost && parts.length > 2;

const Header = () => {
    const theme = useTheme();
    const downMD = useMediaQuery(theme.breakpoints.down('md'));
    const { isLoggedIn, isForceLogin, user } = useAuth();
    const { mode, menuOrientation } = useConfig();
    const { menuMaster } = useGetMenuMaster();
    const drawerOpen = menuMaster.isDashboardDrawerOpened;
    const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

    const [loginForceOpen, setLoginForceOpen] = useState(false);
    const [registerForceOpen, setRegisterForceOpen] = useState(false);
    const [forgotForceOpen, setForgotForceOpen] = useState(false);
    const location = useLocation();

    const [showPopup, setShowPopup] = useState(true);

    const disablePopUp = () => {
        setShowPopup(false);
    };

    const hasAgeConsent = () => {
        return true;
    };

    const forceOpen = (type: string) => {
        setLoginForceOpen(type === 'login');
        setRegisterForceOpen(type === 'register');
        setForgotForceOpen(type === 'forgot');
    };
    const isKycDeclined = user?.kycStatus === 'decline';
    // const isKycVerfied = !(user?.kycStatus === null || user?.kycStatus === 'null');
    const showKycPopup = location.pathname === '/Kyc' || location.pathname === '/Kyc/';
    // debugger;
    const kycLimitTimeAvailbale = !user?.isKycTime; // 3 days kyc time limit reached

    let showSkip = !user?.email && kycLimitTimeAvailbale;
    if (user?.kycStatus === null) showSkip = false;
    const kyCPopUpFalg = isLoggedIn && (user?.kycStatus === null || !user?.email) && !showKycPopup && showPopup;

    const disableDepositWithdraw =
        isLoggedIn &&
        (user?.isTerminal === 'Y' ||
            user?.isSaleOperator === 'Y' ||
            ['SCAN-OPERATOR', 'PAYOUT-OPERATOR'].includes(user?.partnerUserType || ''));
    return (
        <>
            <Container
                className="32143"
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    [theme.breakpoints.down('sm')]: {
                        paddingLeft: '10px',
                        paddingRight: '10px',
                        justifyContent: 'space-between'
                    }
                }}
            >
                {kyCPopUpFalg && false ? (
                    <KycPopUp
                        kycStatus={user.kycStatus}
                        showSkip={showSkip}
                        kycLimitTimeAvailbale={kycLimitTimeAvailbale}
                        disablePopUp={disablePopUp}
                    />
                ) : null}

                {!hasAgeConsent() && <CookieTerms />}

                {isLoggedIn && isKycDeclined && !showKycPopup && showPopup ? (
                    <KycDeclinedPopUp
                        kycLimitTimeAvailbale={kycLimitTimeAvailbale}
                        disablePopUp={disablePopUp}
                        declinedText={user.kycMessage}
                    />
                ) : (
                    ''
                )}
                <Box sx={{ width: downMD ? 'auto' : 240, display: 'flex', alignItems: 'center' }}>
                    <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                        <LogoSection />
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'block', md: 'none' }, flexGrow: 1 }}>
                        <LogoSectionMobile />
                    </Box>
                </Box>

                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} />
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} />

                {!isLoggedIn && (
                    <>
                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Box sx={{ display: { xs: 'block', sm: 'block' } }}>
                                <ForgotSection forgotForceOpen={forgotForceOpen} forceOpen={forceOpen} />
                            </Box>

                            <Box sx={{ display: { xs: 'block', sm: 'block' } }}>
                                <RegisterSection registerForceOpen={registerForceOpen} forceOpen={forceOpen} />
                            </Box>

                            <Box sx={{ display: { xs: 'block', sm: 'block' } }}>
                                <LoginSection loginForceOpen={loginForceOpen || isForceLogin} forceOpen={forceOpen} />
                            </Box>
                        </Box>
                    </>
                )}

                {isLoggedIn && (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '10px',
                                position: 'relative',
                                [theme.breakpoints.down('sm')]: {
                                    gap: '5px',
                                    alignItems: 'center'
                                }
                            }}
                        >
                            <ProfileSection />
                        </Box>
                    </>
                )}

                {/* <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
                <LocalizationSection />
            </Box> */}

                {/* <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box> */}
            </Container>
        </>
    );
};

export default Header;
